module.exports = __webpack_public_path__ + "img/timeline-icon.55aaae28.svg";